import { useLocalStorage } from '@/composables/useLocalStorage';
import { Role, hasRole, hasAdvisorAccess } from '@/composables/useRoles';
import { hasTier } from '@/config/plans';
import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/store/userStore';

const routes = [
  {
    path: '/carbon',
    component: () => import('../views/layouts/CarbonFootPrint.vue'),
    children: [
      // {
      //   path: '/carbon',
      //   name: 'CalculatorRoute',
      //   component: () => import('../views/inventories/Index.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/carbon/setting/:id',
      //   name: 'CalculatorSettingRoute',
      //   component: () => import('../views/inventories/Settings.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/power/:id',
      //   name: 'PowerRoute',
      //   component: () => import('../views/calculator/Electricity.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/transport/:id',
      //   name: 'TransportRoute',
      //   component: () => import('../views/calculator/Transport.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/waste/:id',
      //   name: 'WasteRoute',
      //   component: () => import('../views/calculator/Waste.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/sewage-water/:id',
      //   name: 'SewageRoute',
      //   component: () => import('../views/calculator/Sewage.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/carbon/report',
      //   name: 'ReportRoute',
      //   component: () => import('../views/calculator/Report.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/carbon/emission-factor',
      //   name: 'EmissionFactorRoute',
      //   component: () => import('../views/calculator/EmissionFactor.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/leaks/:id',
      //   name: 'LeaksRoute',
      //   component: () => import('../views/calculator/Leaks.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/reductions/:id',
      //   name: 'ReductionsRoute',
      //   component: () => import('../views/calculator/Reductions.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/other-emissions/:id',
      //   name: 'OtherEmissionsRoute',
      //   component: () => import('../views/calculator/OtherEmissions.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/carbon/setting/:id',
      //   name: 'SettingRoute',
      //   component: () => import('../views/profile/Setting.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
    ]
  },
  {
    path: "/gri",
    component: () => import('../views/layouts/GriMainContent'),
    children: [
      {
        path: '/gri',
        name: 'GridL1Route',
        component: () => import('../views/gri/Questionnaire.vue'),
        meta: {
          authorize: [],
          // GRI puede estar entre las evaluaciones asignadas
          minTier: 'baseline',
        }
      },
    ]
  },
  {
    path: "/long-assessment",
    component: () => import('../views/layouts/GriMainContent'),
    children: [
      {
        path: '/long-assessment/:goToStep?',
        name: 'LongAssessmentRoute',
        component: () => import('../views/assessments/LongAssessment.vue'),
        meta: {
          authorize: []
        }
      },
    ]
  },
  {
    path: "/assessment-report",
    component: () => import('../views/layouts/Main.vue'),
    children: [
      {
        path: '/assessment-report',
        name: 'AssessmentReportRoute',
        component: () => import('../views/assessments/AssessmentReport.vue'),
        meta: {
          authorize: []
        }
      },
    ]
  },
  {
    path: '/combined-assessment',
    name: 'CombinedAssessmentRoute',
    component: () => import('../views/assessments/CombinedAssessment.vue'),
    meta: {
      minTier: 'baseline',
      authorize: []
    }
  },
  {
    path: "/vsme-report",
    component: () => import('../views/layouts/Main.vue'),
    children: [
      {
        path: '/vsme-report',
        name: 'VsmeReportRoute',
        component: () => import('../views/assessments/VsmeReport.vue'),
        meta: {
          minTier: 'baseline',
          authorize: []
        }
      },
    ]
  },
  {
    // Assessment VSME (Norma Voluntaria para pymes de EFRAG). Convive con
    // /combined-assessment, no lo reemplaza — ver docs/vsme-assessment-fe.md.
    //
    // Ruta PLANA, como `/combined-assessment`: la vista monta su propio
    // `AssessmentLayout` (el chrome de los assessments, con el breadcrumb sticky).
    // Antes iba envuelta en `layouts/Main.vue`, que es el layout genérico de
    // dashboard — de ahí que su navegación no se pareciera a la de los otros.
    path: '/vsme-assessment',
    name: 'VsmeAssessmentRoute',
    component: () => import('../views/assessments/VsmeAssessment.vue'),
    meta: {
      minTier: 'baseline',
      authorize: []
    }
  },
  {
    path: "/combined-assessment-report",
    component: () => import('../views/layouts/Main.vue'),
    children: [
      {
        path: '/combined-assessment-report',
        name: 'CombinedAssessmentReportRoute',
        component: () => import('../views/assessments/CombinedAssessmentReport.vue'),
        meta: {
          minTier: 'baseline',
          authorize: []
        }
      },
    ]
  },
  {
    path: "/assessment",
    // component: () => import('../views/layouts/Assessment'),
    children: [
      {
        path: '/assessment/:goToStep?/:review?',
        name: 'AssessmentRoute',
        component: () => import('../views/assessments/Assessment.vue'),
        meta: {
          minTier: 'baseline',
          authorize: []
        }
      },
    ]
  },
  {
    path: "/sustainable",
    children: [
      {
        path: '/sustainable',
        name: 'SustainableRoute',
        component: () => import('../views/SustainableRoute/Index.vue'),
        meta: {
          authorize: []
        }
      },
      // {
      //   path: '/sustainable-legacy',
      //   name: 'SustainableRouteLegacy',
      //   component: () => import('../views/SustainableRoute/Index-legacy.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/sustainable-foundations',
      //   name: 'SustainableFoundationsRoute',
      //   component: () => import('../views/SustainableRoute/SustainabilityFoundations.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/sustainable-actions',
      //   name: 'SustainableActionsRoute',
      //   component: () => import('../views/SustainableRoute/Actions.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/sustainable-task/:id',
      //   name: 'SustainableTaskRoute',
      //   component: () => import('../views/SustainableRoute/Task-legacy.vue/index.js'),
      //   meta: {
      //     authorize: []
      //   }
      // },
    ]
  },
  {
    path: "/sustainable-report",
    children: [
      {
        path: '/sustainable-report',
        name: 'PlanReportRoute',
        component: () => import('../views/assessments/PlanReport.vue'),
        meta: {
          minTier: 'baseline',
          authorize: []
        }
      },
    ]
  },
  // {
  //   path: "/sustainable-report-legacy",
  //   children: [
  //     {
  //       path: '/sustainable-report-legacy',
  //       name: 'GSTCReportLegacyRoute',
  //       component: () => import('../views/assessments/GstcReport-legacy.vue'),
  //       meta: {
  //         authorize: []
  //       }
  //     },
  //   ]
  // },
  {
    path: "/action-plan",
    component: () => import('../views/layouts/Main.vue'),
    children: [
      {
        path: '/action-plan-roadmap',
        name: 'ActionPlanRoadmapRoute',
        component: () => import('../views/ActionPlan/Index.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Goal Sheet (hoja de metas GSTC v4) — paso previo al Action Plan.
        // Mock data self-contained en la vista; sin llamadas al API.
        path: '/goal-sheet',
        name: 'GoalSheetRoute',
        component: () => import('../views/ActionPlan/GoalSheet.vue'),
        meta: {
          authorize: [],
          // Todo /api/goals exige cohort o maintenance: sin esto el usuario
          // llega a la pantalla y se come un 403 en cada llamada.
          minTier: 'cohort',
        }
      },
      {
        // Cartera de tours sostenibles: el estado de TODAS las fichas a la vez.
        // `/tour-design` (abajo) es el drill-down de una. Es también el punto de
        // acceso del módulo desde el rail — antes solo se llegaba por
        // Actividades → chip de cobertura.
        path: '/tour-sheets',
        name: 'TourSheetsRoute',
        component: () => import('../views/ActionPlan/TourSheets.vue'),
        meta: {
          // Sin `requiresCohort`: el gate lo pone el backend (403 con el plan
          // vigente) y la vista lo convierte en upsell, igual que TourDesign.
          authorize: []
        }
      },
      {
        // Ficha de diseño de tour responsable (GSTC v4: A4.3, B5.x, C1.x/C3.2,
        // D4.x, D11.x, D12.x). Datos reales: /api/tour-sheets.
        path: '/tour-design',
        name: 'TourDesignRoute',
        component: () => import('../views/ActionPlan/TourDesign.vue'),
        meta: {
          authorize: []
        }
      },
      {
        path: '/task-detail/:id',
        name: 'ActionPlanTaskDetailRoute',
        component: () => import('../views/ActionPlan/Task.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Reporte mensual de la PROPIA compañía (Owner/Admin). El asesor usa
        // /advisor/monthly-report/:companyId; es la misma vista.
        path: '/monthly-report-builder',
        name: 'CompanyMonthlyReportRoute',
        component: () => import('../views/audit/MonthlyReport.vue'),
        meta: {
          authorize: [Role.Owner, Role.Admin]
        }
      },
      {
        path: '/report-center',
        name: 'ReportCenterRoute',
        component: () => import('../views/reports/ReportHub.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Formulario de cotización para un usuario logueado (ampliar sedes,
        // renovar…): mismo formulario, con la empresa y el contacto prellenados.
        path: '/request-quote',
        name: 'QuoteRequestRoute',
        props: { mode: 'app' },
        component: () => import('../views/quote/QuoteForm.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Reporte editorial animado en canvas, con grabación a video en el
        // navegador. Se entra desde el Report Hub; sin entrada en el menú.
        path: '/editorial-story',
        name: 'EditorialStoryRoute',
        component: () => import('../views/reports/EditorialStory.vue'),
        meta: {
          authorize: []
        }
      },
      {
        path: '/repository',
        name: 'RepositoryFilesRoute',
        component: () => import('../views/repository/Index.vue'),
        meta: {
          authorize: []
        }
      },
    ]
  },
  {
    path: '/training',
    component: () => import('../views/layouts/Main.vue'),
    children: [
      {
        path: '/training',
        name: 'TrainingCenterRoute',
        component: () => import('../views/training/Index.vue'),
        meta: {
          authorize: []
        }
      },
      // {
      //   path: '/training-legacy',
      //   name: 'TrainingCenterLegacyRoute',
      //   component: () => import('../views/training/Index-legacy.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // }
    ]
  },
  {
    path: '/',
    component: () => import('../views/layouts/Main.vue'),
    children: [
      {
        // Deep link del QR/flyer de una red: guarda el código y sigue al home.
        // El Header abre "Unirme a una red" con el código cargado, también
        // después de pasar por el login.
        path: '/join-network',
        name: 'JoinNetworkRoute',
        redirect: (to) => {
          const code = String(to.query.code || '').trim().toUpperCase();
          if (code) { try { localStorage.setItem('gme.join.networkCode', code); } catch { /* sin storage */ } }
          return { name: 'HomeRoute' };
        },
      },
      {
        path: '/',
        name: 'HomeRoute',
        component: () => import('../views/home/Dashboard3.vue'),
        meta: {
          authorize: [],
          // `/` NO se gatea por tier: es la puerta de entrada, y a dónde va
          // cada plan lo decide el bloque "home por tier" del beforeEach.
          // Sin esto caía al default 'launchpad' y una empresa baseline
          // aterrizaba en /upgrade al loguearse, sin llegar nunca a su home.
          minTier: 'baseline',
        }
      },
      // {
      //   path: '/dashboard-legacy',
      //   name: 'DashboardLegacyRoute',
      //   component: () => import('../views/home/DashboardCockpit.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/dash2',
      //   name: 'HomeRoute2',
      //   component: () => import('../views/home/Dashboard2.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/dash',
      //   name: 'HomeRoute3',
      //   component: () => import('../views/home/Dashboard.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/dash-recomendacion-v2',
      //   name: 'HomeRouteRecomendacionV2',
      //   component: () => import('../views/home/Dashboard3.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      // {
      //   path: '/table-demo',
      //   name: 'TableDemoRoute',
      //   component: () => import('../views/home/TableDemo.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      {
        path: '/ceo-dashboard',
        name: 'DashboardCEORoute',
        component: () => import('../views/home/DashboardCEO.vue'),
        meta: {
          authorize: []
        }
      },
      {
        path: '/master-dashboard',
        name: 'MasterDashboardRoute',
        component: () => import('../views/home/MasterDashboard.vue'),
        meta: {
          authorize: []
        }
      },
      // {
      //   path: '/kpi-dashboard',
      //   name: 'KPIDashboardRoute',
      //   component: () => import('../views/home/KPIDashboard.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      {
        path: '/shipping-dashboard',
        name: 'ShippingDashboardRoute',
        component: () => import('../views/home/ShippingDashboard.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Naviera: detalle de un operador de su red.
        path: '/shipping-operator/:companyId',
        name: 'ShippingOperatorRoute',
        component: () => import('../views/home/ShippingOperator.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Naviera: tours que los operadores de su red venden vía ella.
        path: '/shipping-tours',
        name: 'ShippingToursRoute',
        component: () => import('../views/home/ShippingTours.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Naviera: portafolio completo de operadores (02 del Figma).
        path: '/shipping-operators',
        name: 'ShippingOperatorsRoute',
        component: () => import('../views/home/ShippingOperators.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Naviera: código de red, invitaciones y solicitudes de ingreso.
        path: '/shipping-network',
        name: 'ShippingNetworkRoute',
        component: () => import('../views/home/ShippingNetwork.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Naviera: PDFs, exportación, programados e historial.
        path: '/shipping-reports',
        name: 'ShippingReportsRoute',
        component: () => import('../views/home/ShippingReports.vue'),
        meta: {
          authorize: []
        }
      },
      // {
      //   path: '/shipping-dashboard-recomendacion',
      //   name: 'ShippingDashboardRecomendacionRoute',
      //   component: () => import('../views/home/ShippingDashboard-recomendacion.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      {
        path: '/launchpad-journey',
        name: 'LaunchpadJourneyRoute',
        component: () => import('../views/home/LaunchpadJourney-recomendacion.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Plan Hub (189 tasks + Cohort certifications) is a Cohort feature —
        // launchpad gets the reduced "Fundamentals" plan via /sustainable.
        path: '/plans',
        name: 'PlanHubRoute',
        component: () => import('../views/ActionPlan/PlanHub.vue'),
        meta: {
          authorize: [],
          minTier: 'cohort',
        }
      },
      {
        // Assessments hub — lista los assessments asignados (cards). Cohort+.
        path: '/assessments',
        name: 'AssessmentsHubRoute',
        component: () => import('../views/assessments/AssessmentsHub.vue'),
        meta: {
          authorize: [],
          // el hub lista lo ASIGNADO — el gate real es la asignación, no el plan
          minTier: 'baseline',
        }
      },
      {
        // Audit Center era un prototipo con datos mock (ahora AuditCenter-legacy.vue).
        // Advisor Center cubre lo mismo con datos reales; se redirige para no
        // romper enlaces guardados.
        path: '/audit-center',
        redirect: { name: 'AdvisorCenterRoute' },
      },
      {
        path: '/advisor-center',
        name: 'AdvisorCenterRoute',
        component: () => import('../views/audit/AdvisorCenter.vue'),
        meta: {
          authorize: [Role.Auditor, Role.Staff]
        }
      },
      {
        // Monthly progress report for an assigned company (advisor deliverable).
        path: '/advisor/monthly-report/:companyId',
        name: 'MonthlyReportRoute',
        component: () => import('../views/audit/MonthlyReport.vue'),
        meta: {
          authorize: [Role.Auditor, Role.Staff]
        }
      },
      // {
      //   path: '/onboarding',
      //   name: 'OnbordingRoute',
      //   component: () => import('../views/calculator/Onboarding.vue'),
      //   meta: {
      //     authorize: []
      //   }
      // },
      {
        path: '/account',
        name: 'AccountRoute',
        component: () => import('../views/profile/Account.vue'),
        meta: {
          minTier: 'baseline',
          authorize: []
        }
      },
      // {
      //   path: '/manage-team2',
      //   name: 'ManageTeamRoute2',
      //   component: () => import('../views/profile/ManageTeam.vue'),
      //   meta: {
      //     authorize: [Role.Owner, Role.Admin]
      //   }
      // },
      {
        path: '/notifications',
        name: 'NotificationsRoute',
        component: () => import('../views/notifications/Index.vue'),
        meta: {
          authorize: []
        }
      },
      {
        path: '/notification-center',
        name: 'NotificationCenterRoute',
        component: () => import('../views/notifications/NotificationCenter.vue'),
        meta: {
          authorize: []
        }
      },
      // New User Account
      {
        path: '/profile',
        name: 'ProfileRoute',
        component: () => import('../views/Account/Profile.vue'),
        meta: {
          minTier: 'baseline',
          authorize: []
        }
      },
      {
        path: '/suscriptions',
        name: 'SuscriptionRoute',
        component: () => import('../views/Account/Suscriptions.vue'),
        meta: {
          minTier: 'baseline',
          authorize: []
        }
      },
      {
        path: '/payments',
        name: 'PaymentsRoute',
        component: () => import('../views/Account/PaymentHistory.vue'),
        meta: {
          minTier: 'baseline',
          authorize: []
        }
      },
      {
        path: '/notifications',
        name: 'NotificationsRoute',
        component: () => import('../views/Account/Notifications.vue'),
        meta: {
          authorize: []
        }
      },
      {
        path: '/security',
        name: 'SecurityRoute',
        component: () => import('../views/Account/Security.vue'),
        meta: {
          minTier: 'baseline',
          authorize: []
        }
      },
      // New Org
      {
        path: '/company',
        name: 'CompanyRoute',
        component: () => import('../views/Account/Organization/Setting.vue'),
        meta: {
          // Básicos de la organización, no material de upsell: una empresa que pagó
          // baseline tiene que poder gestionar su propia empresa y sus usuarios. Iban
          // en el mismo grupo que Account/Profile/Security (ya en 'baseline') y
          // quedaron afuera de esa pasada, así que caían al default 'launchpad'.
          minTier: 'baseline',
          authorize: [Role.Owner, Role.Admin]
        }
      },
      {
        path: '/locations',
        name: 'LocationsRoute',
        component: () => import('../views/Account/Organization/Locations.vue'),
        meta: {
          authorize: [Role.Owner, Role.Admin]
        }
      },
      {
        path: '/manage-team',
        name: 'ManageTeamRoute',
        component: () => import('../views/Account/Organization/UserRights.vue'),
        meta: {
          // Básicos de la organización, no material de upsell: una empresa que pagó
          // baseline tiene que poder gestionar su propia empresa y sus usuarios. Iban
          // en el mismo grupo que Account/Profile/Security (ya en 'baseline') y
          // quedaron afuera de esa pasada, así que caían al default 'launchpad'.
          minTier: 'baseline',
          authorize: [Role.Owner, Role.Admin]
        }
      },
      {
        path: '/infrastructures',
        name: 'InfrastructuresRoute',
        component: () => import('../views/Account/Organization/Infrastructures.vue'),
        meta: {
          authorize: []
        }
      },
      {
        path: '/activities',
        name: 'ActivitiesRoute',
        component: () => import('../views/Account/Organization/Activities.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Protocolos de empresa: la colección que referencian las fichas de
        // tour. Ver docs/company-protocols-crud-design.md.
        path: '/protocols',
        name: 'ProtocolsRoute',
        component: () => import('../views/Account/Organization/Protocols.vue'),
        meta: {
          authorize: []
        }
      },
      {
        path: '/certifications',
        name: 'CertificationsRoute',
        component: () => import('../views/Account/Organization/Certifications.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Public profile (config + share) is a Cohort feature
        path: '/company-profile',
        name: 'CompanyProfileRoute',
        component: () => import('../views/Account/Organization/PublicProfile.vue'),
        meta: {
          authorize: [],
          minTier: 'cohort',
        }
      },
      {
        path: '/resources',
        name: 'ResourceRoute',
        component: () => import('../views/help/HelpCenter.vue'),
        meta: {
          authorize: []
        }
      },
      {
        // Plan de acompañamiento (guidance sessions) según el plan de la
        // empresa. Todos los planes tienen sesiones → baseline incluido.
        path: '/guidance',
        name: 'GuidanceRoute',
        component: () => import('../views/guidance/Index.vue'),
        meta: {
          authorize: [],
          minTier: 'baseline'
        }
      },
      {
        path: '/schedule',
        name: 'ScheduleRoute',
        component: () => import('../views/schedule/Index.vue'),
        meta: {
          authorize: [],
          minTier: 'cohort'
        }
      },
      {
        path: '/communication',
        name: 'CommunicationHubRoute',
        component: () => import('../views/communication/Index.vue'),
        meta: { authorize: [], minTier: 'cohort' }
      },
      {
        path: '/communication/publications',
        name: 'CommunicationPublicationsRoute',
        component: () => import('../views/communication/Publications.vue'),
        meta: { authorize: [], minTier: 'cohort' }
      },
      {
        path: '/communication/marketing-kit',
        name: 'CommunicationMarketingKitRoute',
        component: () => import('../views/communication/MarketingKit.vue'),
        meta: { authorize: [], minTier: 'cohort' }
      },
      {
        path: '/communication/evidence',
        name: 'CommunicationEvidenceRoute',
        component: () => import('../views/communication/Evidence.vue'),
        meta: { authorize: [], minTier: 'cohort' }
      },
    ]
  },
  {
    path: '/login',
    name: 'LoginRoute',
    meta: {},
    component: () => import('../views/auth/Login.vue'),

  },
  {
    // [DS] Playground de componentes base — referencia viva del re-skin.
    path: '/ds',
    name: 'DsPlaygroundRoute',
    meta: {},
    component: () => import('../views/DsPlayground.vue'),
  },
  {
    // [DS] Sandbox de páginas re-skineadas (sin datos reales) — tuneo del tratamiento.
    path: '/sandbox/dashboard',
    name: 'SandboxDashboardRoute',
    meta: {},
    component: () => import('../views/sandbox/SandboxDashboard.vue'),
  },
  // {
  //   path: '/login-legacy',
  //   name: 'LoginRouteLegacy',
  //   meta: {},
  //   component: () => import('../views/auth/Login-legacy.vue'),
  // },
  // {
  //   path: '/create-account-legacy',
  //   name: 'CreateAccountLegacyRoute',
  //   meta: {},
  //   component: () => import('../views/Account/CreateAccount.vue'),
  // },
  {
    // Redirect old route — /create-account now lives at /purchase
    path: '/create-account',
    redirect: { name: 'PurchaseRoute' },
  },
  {
    path: '/purchase',
    name: 'PurchaseRoute',
    // El checkout es la VÍA DE SALIDA del gating: tiene que ser alcanzable por
    // el tier que quiere subir. Sin `minTier: 'baseline'` cae al default
    // 'launchpad' y una empresa baseline que toca "Upgrade to Launchpad" en
    // /upgrade rebota a /upgrade — el upsell no podía convertir nunca.
    meta: { minTier: 'baseline' },
    component: () => import('../views/purchase/Index.vue'),
  },
  {
    path: '/upgrade',
    name: 'UpgradeRoute',
    meta: {
          minTier: 'baseline', authorize: [] },
    component: () => import('../views/upgrade/Index.vue'),
  },
  {
    path: "/monitor",
    component: () => import('../views/layouts/Monitor'),
    children: [
      {
        path: '/monitor',
        name: 'MonitorRoute',
        component: () => import('../views/monitor/Index.vue'),
        meta: {
          authorize: [],
          minTier: 'cohort',
        }
      },
      {
        path: '/monitor-lobby',
        name: 'MonitorLobbyRoute',
        component: () => import('../views/monitor/Lobby.vue'),
        meta: {
          authorize: [],
          minTier: 'cohort',
        },
      },
      {
        path: '/monitor-report',
        name: 'MonitorReportRoute',
        component: () => import('../views/monitor/Report.vue'),
        meta: {
          authorize: [],
          minTier: 'cohort',
        },
      },
      {
        path: '/monitor-report-legacy',
        name: 'MonitorReportLegacyRoute',
        component: () => import('../views/monitor/ReportLegacy.vue'),
        meta: {
          authorize: [],
          minTier: 'cohort',
        },
      },
      {
        path: '/monitor/quick-estimate',
        name: 'CarbonEstimatorRoute',
        component: () => import('../views/monitor/CarbonEstimator.vue'),
        meta: {
          authorize: []
        },
      },
      {
        // Vista de cartera: el estado de todos los proveedores a la vez.
        // `/evaluate` (abajo) es el drill-down de uno.
        path: '/monitor/suppliers',
        name: 'SupplierDashboardRoute',
        component: () => import('../views/monitor/SupplierDashboard.vue'),
        meta: {
          authorize: [],
          minTier: 'cohort',   // mismo gating que la evaluación
        },
      },
      {
        path: '/monitor/suppliers/evaluate',
        name: 'SupplierEvaluationRoute',
        component: () => import('../views/monitor/SupplierEvaluation.vue'),
        meta: {
          authorize: [],
          minTier: 'cohort',   // acceso para cualquier plan menos Launchpad
        },
      }
    ]
  },
  {
    // Public supplier self-assessment (invited by the operator via link/token).
    path: '/supplier-assessment/:token?',
    name: 'SupplierSelfAssessmentRoute',
    meta: { public: true },
    component: () => import('../views/public/SupplierSelfAssessment.vue'),
  },
  {
    // La SEGUNDA encuesta que recibe un proveedor: firma del compromiso de
    // sostenibilidad. Estado independiente del de la autoevaluación de arriba.
    path: '/supplier-consent/:token?',
    name: 'SupplierConsentRoute',
    meta: { public: true },
    component: () => import('../views/public/SupplierConsent.vue'),
  },
  {
    path: '/shared-sustainable-report/:id',
    name: 'PlanReportPublicRoute',
    meta: { public: true },
    component: () => import('../views/assessments/PlanReportPublic.vue'),
  },
  {
    path: '/sustainability-report/:id',
    name: 'SustainabilityReportAiRoute',
    meta: { public: true },
    component: () => import('../views/reports/SustainabilityReportAi.vue'),
  },
  {
    // Public render of an advisor monthly progress report (shared link by uuid).
    path: '/monthly-report/:id',
    name: 'MonthlyReportPublicRoute',
    meta: { public: true },
    component: () => import('../views/audit/MonthlyReport.vue'),
  },
  {
    path: '/diagnostic',
    name: 'QuickDiagnosticRoute',
    meta: { public: true },
    component: () => import('../views/diagnostic/QuickDiagnostic.vue'),
  },
  {
    // Propuesta compartida por Ventas (enlace con token). Pública, sin sesión.
    // Alias /propuesta/:token: es la URL que arma hoy el backoffice
    // (quoteInputs.publicProposalUrl). Ver GME-APP-PROPUESTA-PUBLICA.md.
    path: '/proposal/:token',
    alias: '/propuesta/:token',
    name: 'PublicProposalRoute',
    meta: { public: true },
    component: () => import('../views/quote/PublicProposal.vue'),
  },
  {
    // Formulario de cotización público (reemplaza el Google Form de ventas).
    // Contrato: docs/quote-form-contract.md.
    path: '/quote',
    name: 'QuoteFormRoute',
    meta: { public: true },
    props: { mode: 'public' },
    component: () => import('../views/quote/QuoteForm.vue'),
  },
  {
    // Catálogo público de cursos de GMEXP Academy (para compartir con clientes).
    path: '/course-catalog',
    alias: '/catalogo-cursos',
    name: 'CourseCatalogRoute',
    meta: { public: true },
    component: () => import('../views/public/CourseCatalog.vue'),
  },
  {
    // Public product demo. `/demo` es la LANDING —hero, qué hace GME, los dos
    // recorridos—: es la entrada que vende. `/demo/explore` es el mapa completo
    // de features, para quien ya quiere ver todo y elegir.
    path: '/demo',
    name: 'DemoRoute',
    meta: { public: true },
    component: () => import('../views/demo/DemoLanding.vue'),
  },
  {
    path: '/demo/explore',
    name: 'DemoExploreRoute',
    meta: { public: true },
    component: () => import('../views/demo/DemoExplore.vue'),
  },
  {
    // Una feature con link propio, para que ventas mande UNA pantalla.
    path: '/demo/f/:id',
    name: 'DemoFeatureRoute',
    meta: { public: true },
    component: () => import('../views/demo/DemoFeature.vue'),
  },
  {
    path: '/demo/:tour(operators|network)',
    name: 'DemoWalkthroughRoute',
    meta: { public: true },
    component: () => import('../views/demo/DemoWalkthrough.vue'),
  },
  {
    path: '/shared-env/:id',
    name: 'ReportPublicEnvRoute',
    meta: { public: true },
    component: () => import('../views/sharedReport/Index.vue'),

  },
  {
    // Public per-company sustainability landing (editorial microsite, GME
    // Academy identity). uuid drives the dynamic data. Distinct from /profile.
    path: '/sustainability/:uuid',
    name: 'SustainabilityLandingRoute',
    meta: { public: true },
    component: () => import('../views/public/SustainabilityLanding.vue'),
  },
  {
    // Detalle público de un tour — solo alcanzable si la Ficha de Tour
    // Responsable existe y pasó la revisión de publicación (el BE devuelve
    // 404 si no). Ruta propia (no un modal) para que sea compartible.
    path: '/sustainability/:uuid/tours/:id',
    name: 'SustainabilityTourDetailRoute',
    meta: { public: true },
    component: () => import('../views/public/SustainabilityTourDetail.vue'),
  },
  {
    // Proveedores dentro del micrositio de una empresa: mismo contenido que
    // /suppliers, con el menú (opciones del landing) y el footer de la empresa.
    path: '/sustainability/:uuid/suppliers',
    name: 'SustainabilitySuppliersRoute',
    meta: { public: true },
    component: () => import('../views/public/SuppliersLanding.vue'),
  },
  {
    // Todos los protocolos publicados de la empresa — a dónde vuelve "Ver
    // todos los protocolos" desde el detalle de un tour.
    path: '/sustainability/:uuid/protocols',
    name: 'SustainabilityProtocolsRoute',
    meta: { public: true },
    component: () => import('../views/public/SustainabilityProtocolsList.vue'),
  },
  {
    // Un protocolo, en su propia página (no un panel) — compartible, y con
    // su propia URL en vez de vivir solo dentro del detalle de un tour.
    path: '/sustainability/:uuid/protocols/:id',
    name: 'SustainabilityProtocolDetailRoute',
    meta: { public: true },
    component: () => import('../views/public/SustainabilityProtocolDetail.vue'),
  },
  {
    path: '/profile/:slug',
    name: 'OrganizationPublicReportRoute',
    meta: { public: true },
    component: () => import('../views/Account/Organization/PublicReport.vue'),
  },
  {
    path: '/profile-legacy/:slug',
    name: 'OrganizationPublicReportLegacyRoute',
    meta: { public: true },
    component: () => import('../views/Account/Organization/PublicReport-legacy.vue'),
  },
  {
    // Catch-all — unknown URLs (incl. retired legacy paths like /carbon/*)
    // go home instead of rendering a blank page. The guard then resolves the
    // right landing per session: launchpad → journey, no token → login.
    path: '/:pathMatch(.*)*',
    name: 'NotFoundRoute',
    redirect: { name: 'HomeRoute' },
  },
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Mismo path, solo cambió el query (tabs, filtros, paginación) → NO saltar al top,
    // mantener la posición de scroll actual.
    if (to.path === from.path) return false;
    // Back/forward → restaurar la posición previa.
    if (savedPosition) return savedPosition;
    // Navegación real a otra ruta → arriba.
    return { top: 0, behavior: 'smooth' };
  },
})

router.beforeEach((to, _from, next) => {
  if (to.meta?.public) return next();

  const { getLocalAccessToken, getUserInfo, getUserCompanyInfo, getSelectedCompanyId } = useLocalStorage();
  const isAuthenticated = getLocalAccessToken();

  // Restore selected child company from localStorage into Pinia store on every navigation.
  // This ensures the Pinia store is always in sync after a page reload (store resets on refresh).
  const savedCompanyId = getSelectedCompanyId();
  if (savedCompanyId) {
    const userStore = useUserStore();
    const numericId = Number(savedCompanyId);
    if (userStore.selectedCompanyId !== numericId) {
      userStore.setSelectedCompany(numericId);
    }
  }
  // Si el usuario intenta ir a una ruta protegida sin un token, redirigir al login

  const { authorize } = to.meta;
  const currentUser = getUserInfo();

  // Master-only routes are not accessible when viewing a child company
  if (to.name === 'LocationsRoute' && savedCompanyId) {
    return next({ name: 'CompanyRoute' });
  }

  // Network owner (naviera) can only access specific routes
  const NETWORK_OWNER_ROUTES = new Set([
    'ShippingDashboardRoute',
    'ShippingToursRoute',
    'ShippingOperatorRoute',
    'ShippingNetworkRoute',
    'ShippingReportsRoute',
    'ShippingOperatorsRoute',
    'ShippingDashboardRecomendacionRoute',
    'CompanyRoute',
    'ManageTeamRoute',
    'ProfileRoute',
    'SuscriptionRoute',
    'PaymentsRoute',
    'SecurityRoute',
    'NotificationsRoute',
    'LoginRoute',
    'CreateAccountLegacyRoute',
    'PurchaseRoute',
  ]);

  // A master takes precedence over the network-owner whitelist: an account that
  // is BOTH (naviera that also owns a group) navigates the app as a master and
  // is NOT locked to the shipping dashboard. Pure navieras stay whitelisted.
  if (currentUser?.isNetworkOwner && !currentUser?.isMaster && to.name && !NETWORK_OWNER_ROUTES.has(to.name)) {
    return next({ name: 'ShippingDashboardRoute' });
  }

  // ShippingDashboard / ShippingTours are only for network owners (navieras)
  if (['ShippingDashboardRoute', 'ShippingToursRoute', 'ShippingOperatorRoute', 'ShippingOperatorsRoute', 'ShippingNetworkRoute', 'ShippingReportsRoute'].includes(to.name) && !currentUser?.isNetworkOwner) {
    return next({ name: 'HomeRoute' });
  }

  // Advisor Center personas — Auditor (4, certifies) and Advisor (5, advises).
  // Both land on the Advisor Center and may only visit it + the surfaces of an
  // ASSIGNED company (scoped by selectedCompanyId -> x-company-id). Never their
  // own company. Mirrors the network-owner whitelist above.
  // This runs BEFORE the subscription/cohort guards below and bypasses them:
  // those read the user's own company tier, which is irrelevant here.
  if (hasAdvisorAccess(currentUser?.rl)) {
    const ADVISOR_ROUTES = new Set([
      'AdvisorCenterRoute',
      'MonthlyReportRoute',
      // Surfaces of an assigned company
      'OrganizationPublicReportRoute',
      'CompanyProfileRoute',
      'ActionPlanRoadmapRoute',
      'ActionPlanTaskDetailRoute',
      'PlanHubRoute',
      // Fichas de tour: el advisor las lee (la vista se pone en solo lectura),
      // igual que el BE, que le permite GET y le niega el PUT.
      'TourDesignRoute',
      'ActivitiesRoute',
      'GoalSheetRoute',
      // Assessment + its report (advisor reviews them, read-only)
      'AssessmentRoute',
      'AssessmentReportRoute',
      'LongAssessmentRoute',
      'PlanReportRoute',
      'MonitorRoute',
      'MonitorLobbyRoute',
      'MonitorReportRoute',
      'CarbonEstimatorRoute',
      'ResourceRoute',
      'TrainingCenterRoute',
      'ReportCenterRoute',
      'ScheduleRoute',
      'GridL1Route',
      'RepositoryFilesRoute',
      // Account / auth basics (advisors: only profile + password/security)
      'ProfileRoute',
      'SecurityRoute',
      'LoginRoute',
    ]);
    if (to.name && !ADVISOR_ROUTES.has(to.name)) {
      return next({ name: 'AdvisorCenterRoute' });
    }
    return next();
  }

  // ── Gate por NIVEL de plan ────────────────────────────────────────────
  // `meta.minTier` dice el escalón mínimo que pide la ruta. Reemplaza al flag
  // binario `requiresCohort`, que con tres tiers ya no alcanzaba.
  //
  // El default es 'launchpad' A PROPÓSITO: una ruta sin `minTier` se comporta
  // exactamente como antes de que existiera baseline, así que launchpad y
  // cohort no cambian de acceso. Solo lo que baseline PUEDE ver se marca
  // explícitamente con `minTier: 'baseline'` — la lista corta, no la larga.
  //
  // Solo aplica a sesiones AUTENTICADAS. Sin token no hay `companyInfo`, y
  // `hasTier(<cualquier cosa>, undefined)` es false porque el piso de la escala
  // es baseline — así que el gate mandaba a /upgrade hasta al visitante anónimo.
  // Eso cerraba un ciclo: `/` → /upgrade → (sin token) → /login → `/login` no
  // declara minTier, cae al default 'launchpad' → /upgrade → … vue-router
  // aborta la navegación por redirección infinita y NO monta nada: pantalla en
  // blanco. El chequeo de tier es sobre el plan de una sesión; sin sesión no
  // hay nada que chequear y el gate de autenticación de más abajo se encarga.
  //
  // Una naviera PURA (isNetworkOwner sin isMaster, sin hijo seleccionado) queda
  // fuera de este gate: sus rutas son la whitelist NETWORK_OWNER_ROUTES y su home
  // es el shipping dashboard, no una superficie de plan. Si entrara, una naviera
  // sin suscripción (`subscriptionType: null`) iría a /upgrade, que no está en la
  // whitelist y la devuelve al shipping dashboard → /upgrade → … vue-router solo
  // corta el ciclo A→A, no A→B→A, y la pestaña se congela sin montar nada.
  const isPureNetworkOwner = !!currentUser?.isNetworkOwner && !currentUser?.isMaster && !savedCompanyId;
  const minTier = to.meta?.minTier ?? 'launchpad';
  if (isAuthenticated && minTier !== 'baseline' && !isPureNetworkOwner) {
    const companyInfo = getUserCompanyInfo();
    if (!hasTier(minTier, companyInfo?.subscriptionType)) {
      return next({ name: 'UpgradeRoute' });
    }
  }

  // /upgrade solo aplica por debajo de cohort. cohort y los tiers superiores
  // (cohort_premium, maintenance) ya tienen acceso completo y hoy no hay un
  // producto superior comprable acá, así que se bloquean como cohort.
  if (to.name === 'UpgradeRoute' && isAuthenticated) {
    const companyInfo = getUserCompanyInfo();
    if (hasTier('cohort', companyInfo?.subscriptionType)) {
      return next({ name: 'HomeRoute' });
    }
  }

  // The full action-plan roadmap is available from cohort tier UPWARD
  // (enterprise inherits it). Below cohort (launchpad/legacy) the tasks
  // live in the journey home — same destination planCtaRoute resolves to.
  // Task detail stays accessible for every tier.
  if (to.name === 'ActionPlanRoadmapRoute' && isAuthenticated) {
    const companyInfo = getUserCompanyInfo();
    if (companyInfo && !hasTier('cohort', companyInfo.subscriptionType)) {
      return next({ name: 'LaunchpadJourneyRoute' });
    }
  }

  // Launchpad companies land on the journey instead of the cohort dashboard.
  // The shared link stays `/` — on upgrade the same URL starts serving the
  // full dashboard with no link change. Only redirect when company info is
  // present so legacy sessions without it keep their current home.
  // When acting on behalf of a selected child (savedCompanyId), the CHILD's plan
  // governs — even for a master/naviera — because gs-company now holds the child
  // context. Otherwise, network owners are exempt (their home is the shipping
  // dashboard, handled above).
  if (to.name === 'HomeRoute' && isAuthenticated && (savedCompanyId || !currentUser?.isNetworkOwner)) {
    const companyInfo = getUserCompanyInfo();
    // baseline primero: es el tier MÁS restrictivo, y su única superficie son
    // las evaluaciones asignadas (el journey de launchpad ya es más de lo que
    // el plan incluye — ver `canAccessActionPlan` en el store).
    if (companyInfo && !hasTier('launchpad', companyInfo.subscriptionType)) {
      return next({ name: 'AssessmentsHubRoute' });
    }
    if (companyInfo && !hasTier('cohort', companyInfo.subscriptionType)) {
      return next({ name: 'LaunchpadJourneyRoute' });
    }
  }

  if (authorize) {
    if ((to.name !== 'LoginRoute' && to.name !== 'CreateAccountLegacyRoute' && to.name !== 'PurchaseRoute' && to.name !== 'DsPlaygroundRoute' && to.name !== 'SandboxDashboardRoute') && !isAuthenticated) {
      return next({ name: 'LoginRoute' });
    }
    if (authorize.length && !hasRole(authorize, currentUser?.rl)) {
        return next({ path: '/' });
    }
  }
  next();
});

export default router
